import {
    DELETE_INTERVIEWER_BY_ADMIN_REQUEST,
    DELETE_INTERVIEWER_BY_ADMIN_SUCCESS,
    DELETE_INTERVIEWER_BY_ADMIN_FAILURE,
} from "../actions";

const initialState = {
    loading: false,
    data: [],
    error: "",
};

const deleteInterviewerByAdminReducer = (state = initialState, action) => {
    switch (action.type) {
        case DELETE_INTERVIEWER_BY_ADMIN_REQUEST:
            return {
                ...state,
                loading: true,
                data: [],
            };

        case DELETE_INTERVIEWER_BY_ADMIN_SUCCESS:
            return {
                loading: false,
                data: action.payload,
                error: "",
            };
        case DELETE_INTERVIEWER_BY_ADMIN_FAILURE:
            return {
                loading: false,
                data: [],
                error: action.payload,
            };
        default:
            return state;
    }
};
export default deleteInterviewerByAdminReducer;
